// import $ from 'jquery';

export default class  {

  constructor() {
    this.lang = 'jp';
  }

  getLang() {
    // console.log(this.lang);
    return this.lang;
  }

  setLang(type) {
   this.lang = type;
  }

}
